import { setupWorker } from 'msw/browser';
import { emailHandlers } from './email_handlers';
import { handlers } from './handlers';
import { incidentsHandlers } from './incidents_handlers';
import { individualOrganizationUsersHandlers } from './individual_organization_users_handlers';
import { individualProductsHandlers } from './individual_products_handlers';
import { invitationLinksHandlers } from './invitation_links_handlers';
import { organizationAdminsHandlers } from './organization_admins_handlers';
import { organizationUsersHandlers } from './organization_users_handlers';
import { organizationsHandlers } from './organizations_handlers';
import { passwordHandlers } from './password_handlers';
import { signateNotificationsHandlers } from './signate_notifications_handlers';
import { smsHandlers } from './sms_handlers';
import { tocHandlers } from './toc_handlers';
import { usersHandlers } from './users_handlers';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}`;

if (typeof window !== 'undefined') {
  const cloudApiHandlers = [
    handlers,
    incidentsHandlers,
    usersHandlers,
    organizationUsersHandlers,
    organizationsHandlers,
    passwordHandlers,
    invitationLinksHandlers,
    organizationAdminsHandlers,
    signateNotificationsHandlers,
    tocHandlers,
    individualOrganizationUsersHandlers,
    emailHandlers,
    smsHandlers,
    individualProductsHandlers,
  ].flat();

  const worker = setupWorker(...cloudApiHandlers);

  worker
    .start({
      onUnhandledRequest(request) {
        const url = new URL(request.url);
        if (!baseUrl.match(url.hostname)) {
          // Cloud API 以外へのリクエストはスルー
          return;
        }

        console.warn(
          'Found an unhandled %s request to %s',
          request.method,
          url.href
        );
      },
    })
    .then();
}
